<template>
  <div class="expert-tool-save">
    <slot name="button" :close="confirm" v-if="appearance === 'button'">
      <v-btn x-large text class="ml-4" @click="confirm">
        {{ $ucfirst($t('general.close', { catalog: 'app_mobile' })) }}
      </v-btn>
    </slot>
    <v-btn @click="confirm" outlined icon color="primary" v-else-if="appearance === 'icon'">
      <v-icon :color="$color.coro.purple">mdi-close</v-icon>
    </v-btn>
    <v-dialog v-model="showDialog" max-width="720px">
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{ $ucfirst($t('expertTool.closeMessages.changesWillBeLost')) }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <expert-tool-save @saved="checkClose" @click="showDialog = false">
            <template #button="{ save }">
              <v-btn @click.stop="save" x-large color="primary" text class="mt-2" :disabled="hasReadOnlyAccess">
                {{ $ucfirst($t('dss.savePrescription')) }}
              </v-btn>
            </template>
          </expert-tool-save>
          <v-btn @click="close" x-large text class="ml-4 mt-2">
            {{ $ucfirst($t('discardChanges')) }}
          </v-btn>
          <v-btn @click="showDialog = false" x-large text class="ml-4 mt-2">
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- Unable to close popup -->
    <v-dialog v-model="showUnableToSaveDialog" width="600px">
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{ $ucfirst($t('expertTool.confirmation.prescriptionIncomplete')) }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <v-btn x-large text class="ml-4" @click="showUnableToSaveDialog = false" color="primary">
            {{ $ucfirst($t('OK')) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExpertToolSave from './ExpertToolSave'
import {isRecommendationChanged} from "../../../store/expert-tool/getters";

/**
 * Component ExpertToolClose.vue
 *
 * @module ExpertToolClose
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/views/ExpertTool/ExpertToolClose.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'ExpertToolClose',
  components: { ExpertToolSave },
  props: {
    appearance: {
      type: String,
      validator: (val) => ['icon', 'button'].includes(val),
      default: 'icon',
    }
  },
  data() {
    return {
      showDialog: false,
      showUnableToSaveDialog: false
    };
  },
  computed: {
    ...mapGetters({
      isRecommendationSaved: 'expertTool/isRecommendationSaved',
      hasRecommendation: 'expertTool/hasRecommendation',
      hasReadOnlyAccess: 'user/hasReadOnlyAccess',
      isSDMStarted: 'followupSession/isSDMStarted'
    }),
  },
  methods: {
    confirm() {
      if(this.isSDMStarted) {
        if (!this.isRecommendationSaved && this.hasRecommendation) {
          this.showDialog = true;
        } else if (!this.hasRecommendation) {
          this.showUnableToSaveDialog = true
        } else {
          this.checkClose();
        }
      } else {
        this.checkClose();
      }
    },
    checkClose() {
      if (!this.isRecommendationSaved && this.$store.state.expertTool.recommendationIsOpen) {
        if (this.hasRecommendation) {
          this.showDialog = true;
          this.showUnableToSaveDialog = false;
        } else {
          this.showDialog = false;
          this.showUnableToSaveDialog = true;
        }
      }else{
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },
    // discard() {
    //   this.$store.dispatch('expertTool/revertRecommendation');
    //   this.showDialog = false;
    // },
  },
};
</script>

<style scoped>
.dashboard-dialog-window__actions {
  flex-wrap: wrap;
}
</style>
